<div class="nutrition-fields" [formGroup]="form">
  <mat-form-field *ngFor="let field of fields" class="nutrition-field" appearance="fill">
    <mat-label>{{ 'MENU.NUTRITION.' + field.toUpperCase() | translate }}</mat-label>
    <input matInput type="number" min="0" [formControlName]="getControlName(field)"
           [class.isDifferent]="isDifferent(field)" (input)="onInput()">
    <mat-icon *ngIf="isDifferent(field)" matSuffix mat-icon-button aria-label="Clear"
              class="restore"
              matTooltip="{{getOriginalValue(field)}}" (click)="restore(field)">restore
    </mat-icon>
  </mat-form-field>
</div>
